module.exports = __webpack_public_path__ + "img/house-flood.492b42bb.svg";